/* Create by CC 2015-12-25
    iwo编辑页面底部按钮权限
*/
'use strict';
angular.module('iWoinitBtnModule', []).factory('iWoinitBtnService', function() {
    return {
        initBtnArrays: function() {
            var personBtnArray = [
                {
                    RIGHTINDEX: 4,
                    OPERDESC: '传稿',
                    OPERFUN: 'iWoTransfer',
                },
                {
                    RIGHTINDEX: 3,
                    OPERDESC: '提交',
                    OPERFUN: 'iWoSubmit',
                },
                {
                    RIGHTINDEX: 229,
                    OPERDESC: '送审',
                    OPERFUN: 'departmentSubmit',
                },
                {
                    RIGHTINDEX: 5,
                    OPERDESC: '共享',
                    OPERFUN: 'iWoshare',
                },
                {
                    RIGHTINDEX: 37,
                    OPERDESC: '发送',
                    OPERFUN: 'sendmessage',
                }
            ];
            var receivedBtnArray = [
                {
                    RIGHTINDEX: 12,
                    OPERDESC: '传稿',
                    OPERFUN: 'iWoTransfer',
                },
                {
                    RIGHTINDEX: 11,
                    OPERDESC: '提交',
                    OPERFUN: 'iWoSubmit',
                },
                {
                    RIGHTINDEX: 229,
                    OPERDESC: '送审',
                    OPERFUN: 'departmentSubmit',
                },
                {
                    RIGHTINDEX: 13,
                    OPERDESC: '共享',
                    OPERFUN: 'iWoshare',
                },
                {
                    RIGHTINDEX: 198,
                    OPERDESC: '发送',
                    OPERFUN: 'sendmessage',
                },
            ];
            var departmentBtnArray = [
                {
                    authorityName: 'deptmentaldoc.deptmentaldoc.tijiao',
                    OPERDESC: '签发',
                    OPERFUN: 'iWoSubmit',
                },
                {
                    authorityName: 'deptmentaldoc.deptmentaldoc.gongxiang',
                    OPERDESC: '共享',
                    OPERFUN: 'iWoshare',
                },
                {
                    authorityName: 'deptmentaldoc.deptmentaldoc.chuandi',
                    OPERDESC: '送审',
                    OPERFUN: 'departmentSubmit',
                },
                {
                    authorityName: 'deptmentaldoc.deptmentaldoc.chakan', // 由于发送按钮现在不做权限控制了，没有权限位名称，所以此处设置为部门稿库的查看权限
                    OPERDESC: '发送',
                    OPERFUN: 'sendmessage',
                }
            ];
            var arrayBtn = [personBtnArray, receivedBtnArray, departmentBtnArray];
            return arrayBtn;
        },
    };
});
